export interface UpdateFiltersPerCategoryArgs<CategoryKey> {
  categoryKey: CategoryKey;
  optionKeysToToggle?: string[];
  optionKeysToUnselect?: string[];
  optionKeysToSelect?: string[];
  shouldClearAllOptions?: boolean;
}

export function updateFiltersPerCategory<T>(
  filtersPerCategory: Record<string, boolean>,
  updateArgs: UpdateFiltersPerCategoryArgs<T>,
) {
  const { optionKeysToToggle, optionKeysToUnselect, optionKeysToSelect, shouldClearAllOptions } = updateArgs;
  const currentFilterState = shouldClearAllOptions ? {} : { ...filtersPerCategory };

  if (optionKeysToToggle?.length) {
    optionKeysToToggle.forEach((optionKeyToToggle) => {
      if (currentFilterState[optionKeyToToggle]) {
        delete currentFilterState[optionKeyToToggle];
      } else {
        currentFilterState[optionKeyToToggle] = true;
      }
    });
  }

  if (optionKeysToUnselect?.length) {
    optionKeysToUnselect.forEach((optionKeyToUnselect) => {
      delete currentFilterState[optionKeyToUnselect];
    });
  }

  if (optionKeysToSelect?.length) {
    optionKeysToSelect.forEach((optionKeyToSelect) => {
      currentFilterState[optionKeyToSelect] = true;
    });
  }

  return currentFilterState;
}
